/**
 * Employee Web — `/me/expenses` landing index route.
 *
 * Renders the expenses landing under the pathless `_auth.me.expenses`
 * parent. Permission gate: `expense:read:self`.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { MeExpensesLanding } from "../features/expenses/MeExpensesLanding";

export const Route = createFileRoute("/_auth/me/expenses/")({
  beforeLoad: requirePermission({
    anyOf: ["expense:read:self"],
    defaultRoute: "/me/overview",
  }),
  component: MeExpensesIndexRoute,
});

function MeExpensesIndexRoute(): JSX.Element {
  return <MeExpensesLanding />;
}
